"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Heading from "./webflow_modules/Basic/components/Heading";
import Image from "./webflow_modules/Basic/components/Image";
import Link from "./webflow_modules/Basic/components/Link";
import Paragraph from "./webflow_modules/Basic/components/Paragraph";
import RichText from "./webflow_modules/Basic/components/RichText";
import Section from "./webflow_modules/Layout/components/Section";
import Span from "./webflow_modules/Basic/components/Span";
import Strong from "./webflow_modules/Basic/components/Strong";
import * as _interactions from "./webflow_modules/interactions";
import { Footer } from "./Footer";
import { Gallery } from "./Gallery";
import { GlobalStyles } from "./GlobalStyles";
import { HeroSubCardComponentContainer } from "./HeroSubCardComponentContainer";
import { Navbar } from "./Navbar";

const _interactionsData = JSON.parse(
  '{"events":{"e-31":{"id":"e-31","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-32"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-32":{"id":"e-32","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-31"}},"mediaQueries":["main"],"target":{"selector":".navbar_interaction-trigger","originalId":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"CLASS"},"targets":[{"id":"65ee92366d1cabac2751eec4|31f447e0-3d13-9796-7034-ff64324af7cc","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1702402485163},"e-131":{"id":"e-131","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-57","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-132"}},"mediaQueries":["main"],"target":{"id":"3ce0f8eb-1267-5c88-ad01-9039544b6a6c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3ce0f8eb-1267-5c88-ad01-9039544b6a6c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941748488},"e-132":{"id":"e-132","name":"","animationType":"preset","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-58","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main"],"target":{"id":"3ce0f8eb-1267-5c88-ad01-9039544b6a6c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3ce0f8eb-1267-5c88-ad01-9039544b6a6c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1707941748488}},"actionLists":{"a-15":{"id":"a-15","title":"Navbar [transparent]","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-16":{"id":"a-16","title":"Navbar [solid]","actionItemGroups":[{"actionItems":[{"id":"a-16-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174},"a-57":{"id":"a-57","title":"Navbar [transparent] 4","actionItemGroups":[{"actionItems":[{"id":"a-57-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]},{"actionItems":[{"id":"a-57-n-2","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":0}}]}],"useFirstGroupAsInitialState":true,"createdOn":1702402503174},"a-58":{"id":"a-58","title":"Navbar [solid] 4","actionItemGroups":[{"actionItems":[{"id":"a-58-n","actionTypeId":"STYLE_BACKGROUND_COLOR","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".navbar","selectorGuids":["067842f2-878c-90e2-6ea0-a6e912dff8f1"]},"globalSwatchId":"","rValue":0,"bValue":202,"gValue":133,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1702402503174}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function PageComponentAccessibilityStatement({}) {
  _interactions.useInteractions(_interactionsData);

  return (
    <Block tag={"div"}>
      <GlobalStyles />
      <Block className={"page-wrapper"} tag={"div"}>
        <Block
          className={"navbar_interaction-trigger"}
          data-w-id={"3ce0f8eb-1267-5c88-ad01-9039544b6a6c"}
          tag={"div"}
        />
        <Navbar />
        <Block className={"main-wrapper"} tag={"main"}>
          <Block className={"header"} tag={"header"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-small"} tag={"div"}>
                <Block className={"header30_content"} tag={"div"}>
                  <Block className={"padding-section-large"} tag={"div"}>
                    <Block className={"text-align-center"} tag={"div"}>
                      <Heading className={"text-color-white"} tag={"h1"}>
                        <Strong>{"Accessibility Statement"}</Strong>
                      </Heading>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
            <Block className={"header30_background-image-wrapper"} tag={"div"}>
              <Block className={"image-overlay-layer"} tag={"div"} />
              <Image
                alt={""}
                className={"header30_background-image"}
                height={"auto"}
                loading={"eager"}
                src={
                  "https://cdn.prod.website-files.com/656bce4e0dae8369c9788229/657cc1e87bc911eb83bd6937_Rectangle%20100.jpg"
                }
                width={"auto"}
              />
            </Block>
          </Block>
          <Section className={"map"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block className={"padding-section-large"} tag={"div"}>
                  <RichText
                    className={"trb-pricacy"}
                    tag={"div"}
                    target={"_blank"}
                  >
                    <Heading tag={"h1"}>
                      {"SRG Residential Accessibility Statement"}
                    </Heading>
                    <Paragraph>
                      <Strong>{"Updated: April 2021."}</Strong>
                    </Paragraph>
                    <Paragraph>{"‍"}</Paragraph>
                    <Heading tag={"h2"}>{"General"}</Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "SRG Residential strives to ensure that its services are accessible to people with disabilities. SRG Residential has invested a significant amount of resources to help ensure that its website is made easier to use and more accessible for people with disabilities, with the strong belief that website accessibility efforts assist all users and that every person has the right to live with dignity, equality, comfort and independence."
                        }
                      </Strong>
                    </Paragraph>
                    <Heading tag={"h2"}>
                      {"Accessibility on www.srgliving.com"}
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {"www.srgliving.com makes available the UserWay's "}
                      </Strong>
                      <Link
                        button={false}
                        options={{
                          href: "https://userway.org/",
                        }}
                      >
                        <Strong>{"Web Accessibility"}</Strong>
                      </Link>
                      <Strong>
                        {
                          " Widget is powered by a dedicated accessibility server. The software allows www.srgliving.com to improve its compliance with the Web Content Accessibility Guidelines (WCAG 2.1)."
                        }
                      </Strong>
                    </Paragraph>
                    <Heading tag={"h2"}>
                      {"Enabling the Accessibility Menu"}
                    </Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "The www.srgliving.com accessibility menu can be enabled by clicking the accessibility menu icon that appears on the corner of the page. After triggering the accessibility menu, please wait a moment for the accessibility menu to load in its entirety."
                        }
                      </Strong>
                    </Paragraph>
                    <Heading tag={"h2"}>{"Disclaimer"}</Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "SRG Residential continues its efforts to constantly improve the accessibility of its site and services in the belief that it is our collective moral obligation to allow seamless, accessible and unhindered use also for those of us with disabilities."
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>
                      <Strong>
                        {
                          "In an ongoing effort to continually improve and remediate accessibility issues, we also regularly scan www.srgliving.com with UserWay's "
                        }
                      </Strong>
                      <Link
                        button={false}
                        options={{
                          href: "https://userway.org/scanner",
                        }}
                      >
                        <Strong>{"Accessibility Scanner"}</Strong>
                      </Link>
                      <Strong>
                        {
                          " to identify and fix every possible accessibility barrier on our site. Despite our efforts to make all pages and content on www.srgliving.com fully accessible, some content may not have yet been fully adapted to the strictest accessibility standards. This may be a result of not having found or identified the most appropriate technological solution."
                        }
                      </Strong>
                    </Paragraph>
                    <Heading tag={"h2"}>{"Here For You"}</Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "If you are experiencing difficulty with any content on www.srgliving.com or require assistance with any part of our site, please contact us during normal business hours as detailed below and we will be happy to assist."
                        }
                      </Strong>
                    </Paragraph>
                    <Heading tag={"h2"}>{"Contact Us"}</Heading>
                    <Paragraph>
                      <Strong>
                        {
                          "If you wish to report an accessibility issue, have any questions or need assistance, please contact SRG Residential Customer Support as follows:"
                        }
                      </Strong>
                    </Paragraph>
                    <Paragraph>
                      <Strong>{"Contact Form: "}</Strong>
                      <Link
                        button={false}
                        options={{
                          href: "https://www.srgliving.com/contact-us/",
                        }}
                      >
                        <Strong>
                          {"https://www.srgliving.com/contact-us/"}
                        </Strong>
                      </Link>
                    </Paragraph>
                  </RichText>
                </Block>
              </Block>
            </Block>
          </Section>
          <Section className={"current-residents"} tag={"section"}>
            <Block className={"padding-global"} tag={"div"}>
              <Block className={"container-large"} tag={"div"} />
            </Block>
          </Section>
          <HeroSubCardComponentContainer />
          <Section
            className={"difference_component background-color-grey"}
            tag={"section"}
          >
            <Block className={"padding-global mobile-none"} tag={"div"}>
              <Block className={"container-large"} tag={"div"}>
                <Block tag={"div"}>
                  <Block className={"mobile-padding-global"} tag={"div"}>
                    <Block className={"communities_header"} tag={"div"}>
                      <Block
                        className={"difference_heading-wrapper"}
                        tag={"div"}
                      >
                        <Heading tag={"h2"}>
                          {"THE SRG "}
                          <Span className={"text-color-blue"}>
                            {"Difference"}
                          </Span>
                        </Heading>
                      </Block>
                      <Block
                        className={"decoration-line is-black"}
                        tag={"wrapper"}
                      />
                    </Block>
                  </Block>
                  <Block className={"div-block-34"} tag={"div"}>
                    <Block className={"mobile-padding-global"} tag={"div"}>
                      <Block className={"max-width-medium"} tag={"div"}>
                        <Paragraph className={"text-size-medium"}>
                          {
                            "At SRG Residential, we take utmost pride in being a reliable support system for our residents and employees, fostering strong and vibrant communities where everyone feels valued and cared for. We understand the importance of loving where you live and that's why we are committed to providing hassle-free living experiences."
                          }
                        </Paragraph>
                      </Block>
                    </Block>
                    <Block className={"stats-background is-grey"} tag={"div"}>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Locations"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"150+"}
                        </Block>
                      </Block>
                      <Block tag={"div"}>
                        <Block
                          className={"heading-style-h6 text-color-black"}
                          tag={"div"}
                        >
                          {"Founded"}
                        </Block>
                        <Block
                          className={"heading-style-h1 text-color-blue"}
                          tag={"div"}
                        >
                          {"1993"}
                        </Block>
                      </Block>
                    </Block>
                  </Block>
                </Block>
              </Block>
            </Block>
          </Section>
          <Gallery />
        </Block>
        <Footer />
      </Block>
    </Block>
  );
}
